import { h } from '@stencil/core';
import { VARIANT_RENDERED_PROPS } from './constants';
export class CtaPrice {
  constructor() {
    this.priceHTML = undefined;
    this.secondaryPrice = undefined;
    this.previousPriceHTML = undefined;
    this.tooltipHTML = undefined;
    this.priceFromLabel = undefined;
    this.materialPriceGroup = undefined;
    this.inStockLabel = undefined;
    this.vatLabel = undefined;
    this.resellerLabel = undefined;
    this.isBundle = undefined;
    this.bundleLabel = undefined;
    this.qty = undefined;
    this.variant = 'default';
    this.previousPriceVariant = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getPropForCurrentVariant(propName) {
    var _a;
    if (this.variant === 'default' || !(this.variant in VARIANT_RENDERED_PROPS)) {
      return this[propName];
    }
    return ((_a = VARIANT_RENDERED_PROPS[this.variant]) === null || _a === void 0 ? void 0 : _a.includes(propName)) ? this[propName] : null;
  }
  getCurrentVariantProps() {
    return [
      'priceHTML',
      'previousPriceHTML',
      'tooltipHTML',
      'priceFromLabel',
      'materialPriceGroup',
      'inStockLabel',
      'vatLabel',
      'resellerLabel',
      'bundleLabel',
    ].reduce((acc, propName) => {
      acc[propName] = this.getPropForCurrentVariant(propName);
      return acc;
    }, {});
  }
  render() {
    if (!this.priceHTML) {
      return null;
    }
    const { inStockLabel, priceFromLabel, previousPriceHTML, tooltipHTML, vatLabel, resellerLabel, materialPriceGroup, bundleLabel, } = this.getCurrentVariantProps();
    return (h("div", { class: "cta-price" }, inStockLabel && h("span", { class: "cta-price__in-stock-label" }, inStockLabel), (materialPriceGroup === null || materialPriceGroup === void 0 ? void 0 : materialPriceGroup.label) && (materialPriceGroup === null || materialPriceGroup === void 0 ? void 0 : materialPriceGroup.price) && (h("div", { class: "cta-price__material-group" }, materialPriceGroup.label, ": ", materialPriceGroup.price)), priceFromLabel && h("div", { class: "cta-price__label" }, priceFromLabel, ":"), h("div", { class: "cta-price__text-content" }, this.isBundle ? (h("div", { class: "cta-price__wrapper" }, h("div", { class: {
        'cta-price__text': true,
        'cta-price__text--sticky-bar': this.variant === 'stickyBar',
      }, innerHTML: this.priceHTML }), h("div", { class: "cta-price__bundle-label", innerHTML: this.qty === 1 ? bundleLabel : bundleLabel.replace('#items qty#', `${this.qty}`) }))) : (h("div", { class: {
        filter_pricearea: this.previousPriceVariant === 'beside',
      } }, this.previousPriceVariant && previousPriceHTML && (h("div", { class: "cta-price__previous beside" }, h("strike", { innerHTML: previousPriceHTML }))), h("div", { class: {
        'cta-price__text': true,
        'cta-price__text--sticky-bar': this.variant === 'stickyBar',
      }, innerHTML: this.priceHTML }))), !this.previousPriceVariant && previousPriceHTML && (h("div", { class: "cta-price__previous" }, h("strike", { innerHTML: previousPriceHTML }))), tooltipHTML && (h("pdp-icon-tooltip", { class: "cta-price__tooltip-icon", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "bottom" }, tooltipHTML))), this.secondaryPrice && (h("div", { class: "cta-price__text-content cta-price__text-content--secondary" }, h("div", { class: "cta-price__text", innerHTML: this.secondaryPrice }))), vatLabel && h("div", { class: "cta-price__vat-label", innerHTML: vatLabel }), resellerLabel && h("div", { class: "cta-price__reseller-label", innerHTML: resellerLabel })));
  }
  static get is() { return "pes-cta-price"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-cta-price.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-cta-price.css"]
    };
  }
  static get properties() {
    return {
      "priceHTML": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "price-h-t-m-l",
        "reflect": false
      },
      "secondaryPrice": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "secondary-price",
        "reflect": false
      },
      "previousPriceHTML": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "previous-price-h-t-m-l",
        "reflect": false
      },
      "tooltipHTML": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "tooltip-h-t-m-l",
        "reflect": false
      },
      "priceFromLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "price-from-label",
        "reflect": false
      },
      "materialPriceGroup": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TMaterialPriceGroup",
          "resolved": "{ price: string; label: string; }",
          "references": {
            "TMaterialPriceGroup": {
              "location": "import",
              "path": "../pes-cta-area-view/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "inStockLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "in-stock-label",
        "reflect": false
      },
      "vatLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "vat-label",
        "reflect": false
      },
      "resellerLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "reseller-label",
        "reflect": false
      },
      "isBundle": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-bundle",
        "reflect": false
      },
      "bundleLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "bundle-label",
        "reflect": false
      },
      "qty": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "qty",
        "reflect": false
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'default' | 'stickyBar' | 'grid' | 'list'",
          "resolved": "\"default\" | \"grid\" | \"list\" | \"stickyBar\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": true,
        "defaultValue": "'default'"
      },
      "previousPriceVariant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "previous-price-variant",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
}
